import { render, staticRenderFns } from "./McstStatIntro.vue?vue&type=template&id=12c09224&scoped=true"
import script from "./McstStatIntro.vue?vue&type=script&lang=js"
export * from "./McstStatIntro.vue?vue&type=script&lang=js"
import style0 from "./McstStatIntro.vue?vue&type=style&index=0&id=12c09224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c09224",
  null
  
)

export default component.exports